var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "u-relative" },
    [
      !_vm.isHideUpload
        ? _c(
            "el-upload",
            {
              class: { hide: _vm.isHideUpload },
              attrs: {
                action: _vm.action,
                "file-list": _vm.fileList,
                headers: _vm.headers,
                limit: _vm.limitCount,
                "on-change": _vm.onChange,
                "on-preview": _vm.onPreview,
                "on-remove": _vm.onRemove,
                "on-success": _vm.onSuccess,
                "show-file-list": false,
                drag: "",
                "list-type": "picture-card",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "el-upload__text",
                  staticStyle: { "white-space": "pre-line" },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "u-font-18 u-c-gray u-m-t-10",
                      staticStyle: { height: "20px !important" },
                    },
                    [_vm._v("上传营业执照")]
                  ),
                  _c("br"),
                  _c(
                    "span",
                    {
                      staticClass: "u-font-18 u-c-gray",
                      staticStyle: { height: "20px !important" },
                    },
                    [_vm._v("可识别企业信息")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip",
                },
                [_vm._v("请上传大小不超过2Mb的jpg/png文件")]
              ),
            ]
          )
        : _c("div", { staticClass: "upload-size" }, [
            _c("img", {
              attrs: {
                border: 6,
                src: _vm.bigImgUrl,
                alt: "",
                height: "178px",
                width: "178px",
              },
            }),
          ]),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.isShowBigImg, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.isShowBigImg = $event
            },
          },
        },
        [_c("img", { attrs: { src: _vm.bigImgUrl, alt: "", width: "100%" } })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }